import React, { FC } from "react";

import { MenuBanner, Column, DesktopMenuList, Row } from "../../../components";

const DMShoesFlyout: FC = () => {
  return (
    <Row>
      <Column>
        <Row>
          <Column>
            <DesktopMenuList
              linksItems={[
                { text: "Hiking and outdoor shoes" },
                { text: "Indoor shoes" },
                { text: "Tennis shoes" },
                { text: "Running shoes" },
              ]}
            />
          </Column>
          <Column>
            <DesktopMenuList
              linksItems={[
                { text: "Golf shoes" },
                { text: "Exercise and training shoes" },
                { text: "Basketball shoes" },
                { text: "Sneakers" },
                { text: "Football shoes" },
              ]}
            />
          </Column>

          <Column>
            <DesktopMenuList
              linksItems={[
                { text: "Sandals and slippers" },
                { text: "Biking shoes" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
          </Column>
          <Column />
          <Column />
        </Row>
      </Column>
      <Column xs={2}>
        <MenuBanner
          image={{ src: "assets/images/placeholder-1.png", alt: "placeholder" }}
          title="50% OFF ALL NIKE GEAR"
          description="Get the latest nike gear for a great discount."
          link={{ href: "/" }}
        />
      </Column>
    </Row>
  );
};

export default DMShoesFlyout;
